import * as bs58 from 'bs58'

function setCachedSignature(
  cacheKey: string,
  sig: SignInSignature,
  wallet: any,
) {
  const { publicKey } = wallet
  localStorage.setItem(
    cacheKey,
    JSON.stringify({
      ...sig,
      publicKey: publicKey?.toBase58(),
    } as CachedSignInSignature),
  )
}

export function getCachedSignatureWallet(): string {
  const cacheKey = 'sign-in-signature-status'
  const cachedSig = JSON.parse(
    localStorage.getItem(cacheKey) as string,
  ) as CachedSignInSignature
  return cachedSig?.publicKey
}

async function getCachedSignature(
  wallet: any,
  cacheKey: string,
  maxFreshness = Number(process.env.NEXT_PUBLIC_SIGNATURE_MAX_FRESHNESS) || 2592000, // by seconds
): Promise<SignInSignature | null> {
  try {
    const { publicKey } = wallet
    const cachedSig = JSON.parse(
      localStorage.getItem(cacheKey) as string,
    ) as CachedSignInSignature
    const { msg, signature } = cachedSig

    const currentTime = Date.now()
    const cachedBlockTime = Number(msg)
    if (
      currentTime - cachedBlockTime > maxFreshness * 1000 ||
      cachedSig.publicKey !== publicKey?.toBase58()
    ) {
      return null
    }
    return {
      msg,
      signature,
    }
  } catch {
    return null
  }
}

export interface SignInSignature {
  msg: string
  signature: string
}

interface CachedSignInSignature extends SignInSignature {
  publicKey: string
}

export async function getSignatureForSignIn(wallet: any) {
  try {
    const { signMessage } = wallet

    const msg = Date.now().toString()
    const cacheKey = 'sign-in-signature-status'
    const cachedSig = await getCachedSignature(wallet, cacheKey)
    if (cachedSig) {
      return cachedSig
    }

    const encoder = new TextEncoder()
    if (!signMessage) return
    const signature = bs58.encode(await signMessage(encoder.encode(msg)))
    const signInSignature = {
      msg,
      signature,
    }
    setCachedSignature(cacheKey, signInSignature, wallet)
    return signInSignature
  } catch {
    throw new Error('Failed to get signature from user')
  }
}
